// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.container {
  --scrollbar-bg-color: var(--base-10);
  --scrollbar-thumb-color: var(--base-70_30);
  overscroll-behavior: contain;
  position: relative;
}

/* month cell номер дня текущего месяца */
.view-month .rbc-date-cell .month-day {
  font: var(--font-body-4);
  text-align: left;
  color: var(--base-110);
  display: flex;
  padding: 4px;
}

/* month cell номер дня вне текущего месяца */
.view-month .rbc-date-cell.rbc-off-range .month-day {
  color: var(--base-80);
}

/* month cell номер дня текущего месяца выделение */
.view-month .rbc-date-cell.rbc-now .month-day .month-day-content {
  border-radius: 50%;
  background-color: var(--brand-primary-40);
  color: var(--addition-50);
}

.view-month .rbc-date-cell .month-day .month-day-content {
  width: 40px;
  padding: 8px 0px;
  text-align: center;
}

.view-month .rbc-date-cell {
  /* padding: 4px; */
}

/* month cell удаление bg текущего дня */
.view-month .rbc-month-row .rbc-today {
  background-color: transparent;
}

/* month header с именем дня недели */
.view-month .month-day-name-header {
  color: var(--base-80);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  padding: 4px 0;
}

.view-week .rbc-time-column .rbc-timeslot-group,
.view-day .rbc-time-column .rbc-timeslot-group {
  min-height: 80px;
}

.view-day .rbc-time-column .rbc-timeslot-group {
  border-bottom: none;
}

/* day левая колонка времени */
.view-day .rbc-time-column.rbc-time-gutter .rbc-timeslot-group {
  position: relative;
}

.view-day .rbc-time-column.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {
  text-align: center;
}

/* week левая колонка времени */
.view-week .rbc-time-column.rbc-time-gutter .rbc-timeslot-group {
  position: relative;
  border-bottom: none;
}

/* week header */
.view-week .rbc-time-header,
.view-day .rbc-time-header {
  box-shadow: 0 1px 8px 0 var(--base-20);
  border-inset-inline-end: none;
  margin-inline-end: 0 !important;
  border-bottom: 1px solid var(--base-20);
}

.view-week .rbc-time-header-content,
.view-day .rbc-time-header-content {
  border-left: none;
  padding-bottom: 8px;
}

.is-compact-view.view-day .rbc-time-header-content {
  border-left: none;
  padding-bottom: 0;
}

.view-week .rbc-time-header-cell .rbc-header + .rbc-header,
.rbc-time-header-cell .rbc-header,
.rbc-allday-cell .rbc-day-bg + .rbc-day-bg {
  border: none;
}

.view-week .rbc-header {
  padding: 0;
  text-align: left;
}

.view-week .week-header {
  width: 40px;
  padding-top: 4px;
}

/* week header с именем дня недели */
.view-week .week-name-header {
  color: var(--base-80);
  letter-spacing: var(--font-spacing-subtitle-4);
  font: var(--font-subtitle-4);
}

/* week header с номером дня */
.view-week .week-day-header {
  color: var(--base-110);
  font: var(--font-body-4);
  width: 40px;
  padding: 8px 0px;
}

/* week header текущая колонка */
.view-week .rbc-today {
  background-color: transparent;
}

/* week header с номером текущего дня */
.view-week .rbc-today .week-day-header {
  border-radius: 50%;
  background-color: var(--brand-primary-40);
  color: var(--addition-50);
}

/* week header wrapper с датой и днем */
.view-week .rbc-time-view .rbc-row,
.view-day .rbc-time-view .rbc-row {
  min-height: auto;
}

/* week label у недели (не получается кастомизировать) */
.view-week .rbc-day-slot .rbc-event-label {
  display: none;
}

.is-compact-view.view-day .rbc-time-view {
  padding-left: 8px;
}

.view-week .rbc-time-view,
.view-week .rbc-time-content,
.view-day .rbc-time-view,
.view-day .rbc-time-content {
  border: none;
}

.view-day .rbc-time-content > *:not(.rbc-time-gutter) {
  border-left: 1px solid var(--base-20);
}

.view-day .rbc-time-content > .rbc-time-gutter .rbc-timeslot-group:first-child .rbc-time-slot:first-child,
.view-week .rbc-time-content > .rbc-time-gutter .rbc-timeslot-group:first-child .rbc-time-slot:first-child {
  display: none;
}

.view-week .rbc-time-content > *:not(.rbc-time-gutter) {
  border-left: 1px solid var(--base-20);
}

/* Works on Safari, Safari iOS */
.rbc-time-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: var(--scrollbar-bg-color);
}

/* Works on Safari, Safari iOS */
.rbc-time-content::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb-color);
  border-radius: 10px;
}

/* Works on Firefox, Chrome, Edge, Opera */
@supports (scrollbar-color: #888 #f1f1f1) {
  .container {
    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);
    scrollbar-width: thin;
  }
}
.view-day .rbc-current-time-indicator,
.view-week .rbc-current-time-indicator {
  display: flex !important;
  border: none;
  z-index: 0;
  height: 1px;
  background-color: var(--brand-primary-40);
  margin-inline-start: 4px;
}

/* day label у дня (не получается кастомизировать) */
.view-day .rbc-event .rbc-event-label {
  display: none;
}

/* Цветная точка */
.view-day .rbc-current-time-indicator::after,
.view-week .rbc-current-time-indicator::after {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--brand-primary-40);
  margin-inline-start: 0;
  z-index: 1;
  position: absolute;
  inset-inline-start: -8px;
  transform: translateY(-50%);
}

.view-day .rbc-timeslot-group .rbc-time-slot .rbc-label,
.view-week .rbc-timeslot-group .rbc-time-slot .rbc-label {
  display: inline-block;
  min-width: 38px;
  box-sizing: content-box;
  transform: translateY(-9px);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-90);
  padding: 0 8px;
}

.view-day .rbc-day-slot .rbc-timeslot-group,
.view-week .rbc-day-slot .rbc-timeslot-group {
  border-left: none;
  border-bottom: 1px solid var(--base-20);
}

.view-day .rbc-timeslot-group .rbc-time-slot,
.view-week .rbc-timeslot-group .rbc-time-slot {
  border-top: none;
}

.view-week .rbc-time-column.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {
  text-align: center;
}

.view-day .rbc-day-slot .rbc-events-container,
.view-week .rbc-day-slot .rbc-events-container {
  margin-inline-end: 6px;
}

.rbc-show-more {
  width: 100%;
  background-color: var(--base-17);
  border-radius: 4px;
  padding: 0 4px;
  text-align: center;
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-90);
}

.rbc-row-segment .rbc-show-more:hover,
.rbc-row-segment .rbc-show-more:focus {
  background-color: var(--base-20);
  color: var(--base-90);
}

.rbc-row-segment .rbc-show-more:active {
  background-color: var(--base-20);
  color: var(--base-90);
}

.view-month .rbc-row-segment:has(.rbc-show-more) {
  /* min-height: 30px; */
}

.view-day .rbc-row-segment,
.view-week .rbc-row-segment {
  padding-top: 0px;
  padding-bottom: 1px;
  padding-inline-start: 0px;
  padding-inline-end: 1px;
}

.view-month .rbc-row-segment {
  padding-top: 0px;
  padding-bottom: 1px;
  padding-inline-start: 2px;
  padding-inline-end: 3px;
}

.view-day .rbc-event,
.view-week .rbc-event,
.view-month .rbc-event {
  border: none;
  border-radius: 4px;
  letter-spacing: var(--font-spacing-subtitle-3);
  padding: 0 4px;
}

.rbc-event:has(.event-container-template) {
  color: var(--brand-secondary-70);
  background-color: var(--brand-secondary-0);
  outline: none;
}

.rbc-event:has(.purple) {
  color: var(--brand-secondary-70);
  outline: none;
}

.rbc-event:has(.purple):has(.strike) {
  text-decoration-line: line-through;
  text-decoration-color: var(--brand-secondary-70);
}

.rbc-event:has(.purple):has(.disabled) {
  opacity: 0.5;
}

.rbc-event:has(.sharding):has(.purple) {
  background-image: url("/static/images/purple-sharding.png");
  background-size: 12px 12px;
  background-color: var(--brand-secondary-40_10);
  --event-background-hover-color: var(--brand-secondary-40_20);
  --event-background-selected-color: var(--brand-secondary-40_30);
}

.rbc-event:has(.filled):has(.purple) {
  background-color: var(--brand-secondary-40_10);
  --event-background-hover-color: var(--brand-secondary-40_20);
  --event-background-selected-color: var(--brand-secondary-40_30);
}

.rbc-event:has(.stroke):has(.purple) {
  border: 1px solid var(--brand-secondary-40_40);
  background-color: transparent;
  --event-background-hover-color: var(--brand-secondary-40_10);
  --event-background-selected-color: var(--brand-secondary-40_20);
}

.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):focus,
.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):focus,
.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):focus {
  background-color: var(--brand-secondary-0);
}

.rbc-event:has(.blue) {
  color: var(--info-70);
  outline: none;
}

.rbc-event:has(.blue):has(.strike) {
  text-decoration-line: line-through;
  text-decoration-color: var(--info-70);
}

.rbc-event:has(.blue):has(.disabled) {
  opacity: 0.5;
}

.rbc-event:has(.sharding):has(.blue) {
  background-image: url("/static/images/blue-sharding.png");
  background-size: 12px 12px;
  background-color: var(--info-40_10);
  --event-background-hover-color: var(--info-40_20);
  --event-background-selected-color: var(--info-40_30);
}

.rbc-event:has(.filled):has(.blue) {
  background-color: var(--info-40_10);
  --event-background-hover-color: var(--info-40_20);
  --event-background-selected-color: var(--info-40_30);
}

.rbc-event:has(.stroke):has(.blue) {
  border: 1px solid var(--info-40_40);
  background-color: transparent;
  --event-background-hover-color: var(--info-40_10);
  --event-background-selected-color: var(--info-40_20);
}

.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):focus,
.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):focus {
  background-color: var(--info-0);
}

.rbc-event:has(.green) {
  color: var(--success-70);
  outline: none;
}

.rbc-event:has(.green):has(.strike) {
  text-decoration-line: line-through;
  text-decoration-color: var(--success-70);
}

.rbc-event:has(.green):has(.disabled) {
  opacity: 0.5;
}

.rbc-event:has(.sharding):has(.blue) {
  background-image: url("/static/images/green-sharding.png");
  background-size: 12px 12px;
  background-color: var(--success-40_10);
  --event-background-hover-color: var(--success-40_20);
  --event-background-selected-color: var(--success-40_30);
}

.rbc-event:has(.filled):has(.green) {
  background-color: var(--success-40_10);
  --event-background-hover-color: var(--success-40_20);
  --event-background-selected-color: var(--success-40_30);
}

.rbc-event:has(.stroke):has(.green) {
  border: 1px solid var(--success-40_40);
  background-color: transparent;
  --event-background-hover-color: var(--success-40_10);
  --event-background-selected-color: var(--success-40_20);
}

.rbc-event:has(.filled):has(.green):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.filled):has(.green):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.filled):has(.green):not(:has(.disabled)):focus,
.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):focus {
  background-color: var(--success-0);
}

.rbc-event:has(.pink) {
  color: var(--auxillary-70);
  outline: none;
}

.rbc-event:has(.pink):has(.strike) {
  text-decoration-line: line-through;
  text-decoration-color: var(--auxillary-70);
}

.rbc-event:has(.pink):has(.disabled) {
  opacity: 0.5;
}

.rbc-event:has(.sharding):has(.pink) {
  background-image: url("/static/images/pink-sharding.png");
  background-size: 12px 12px;
  background-color: var(--auxillary-40_10);
  --event-background-hover-color: var(--auxillary-40_20);
  --event-background-selected-color: var(--auxillary-40_30);
}

.rbc-event:has(.filled):has(.pink) {
  background-color: var(--auxillary-40_10);
  --event-background-hover-color: var(--auxillary-40_20);
  --event-background-selected-color: var(--auxillary-40_30);
}

.rbc-event:has(.stroke):has(.pink) {
  border: 1px solid var(--auxillary-40_40);
  background-color: transparent;
  --event-background-hover-color: var(--auxillary-40_10);
  --event-background-selected-color: var(--auxillary-40_20);
}

.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):hover {
  background-color: var(--event-background-hover-color);
}

.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):active {
  background-color: var(--event-background-selected-color);
}

.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):focus,
.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):focus {
  background-color: var(--auxillary-0);
}

.rbc-day-slot .rbc-event-content {
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-container {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
}

.event-container-content {
  white-space: nowrap;
}

.event-container-content-wrap {
  display: flex;
  flex-direction: column;
}

.event-content-title {
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  margin-inline-end: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-content-sub-title {
  white-space: nowrap;
  overflow: hidden;
}

.event-content-prev-sub-title {
  margin-inline-end: 2px;
}

.view-month .rbc-month-view {
  border: 0px;
  overflow: auto;
}

/* TODO */
.view-month .rbc-month-row {
  min-height: fit-content;
}

.view-month .rbc-off-range-bg {
  background-color: transparent;
}

.view-month .rbc-header + .rbc-header {
  border-left: 1px solid var(--base-20);
}

.view-month .rbc-header {
  border-bottom: 1px solid var(--base-20);
}

.view-month .rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid var(--base-20);
}

.view-month .rbc-month-row + .rbc-month-row {
  border-top: 1px solid var(--base-20);
}

.view-day .rbc-addons-dnd-row-body,
.view-week .rbc-addons-dnd-row-body {
  max-height: 200px;
  overflow: auto;
}

.view-day .rbc-addons-dnd-row-body:has(.rbc-row-segment),
.view-week .rbc-addons-dnd-row-body:has(.rbc-row-segment) {
  margin-top: 16px;
}

.is-compact-view.view-day .rbc-addons-dnd-row-body:has(.rbc-row-segment) {
  margin: 8px 0;
}

/* Works on Safari, Safari iOS */
.rbc-addons-dnd-row-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: var(--scrollbar-bg-color);
}

/* Works on Safari, Safari iOS */
.rbc-addons-dnd-row-body::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb-color);
  border-radius: 10px;
}

/* Works on Firefox, Chrome, Edge, Opera */
@supports (scrollbar-color: #888 #f1f1f1) {
  .rbc-addons-dnd-row-body {
    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);
    scrollbar-width: thin;
  }
}
.view-day .rbc-time-header-cell-single-day {
  display: flex;
}

.is-compact-view.view-day .rbc-time-header-cell-single-day {
  display: none;
}

.rbc-row-content {
  z-index: 0;
}

/* day header с именем дня */
.view-day .day-name-header {
  color: var(--base-80);
  letter-spacing: var(--font-spacing-subtitle-4);
  font: var(--font-subtitle-4);
  padding-top: 4px;
}

/* day header с номером дня */
.view-day .day-number-header {
  color: var(--base-110);
  font: var(--font-body-4);
  width: 40px;
  padding: 8px 0px;
}

.view-day .rbc-today {
  background-color: transparent;
}

.view-day .rbc-today .day-number-header {
  border-radius: 50%;
  background-color: var(--brand-primary-40);
  color: var(--addition-50);
}

.view-day .rbc-header {
  padding: 0;
  text-align: start;
}

.view-month .container-toolbar {
  box-shadow: 0 1px 8px 0 var(--base-20);
}

.rbc-slot-selection {
  background-color: var(--brand-secondary-0);
  color: var(--brand-secondary-70);
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 3px;
  width: calc(100% - 6px);
  white-space: nowrap;
  overflow: hidden;
}

/* На месяц/алдей — выделение клеток: */
.rbc-selected-cell {
  background-color: var(--brand-secondary-0);
  border-radius: 4px;
  height: calc(100% - 6px);
}

.view-week .rbc-day-slot .rbc-event,
.view-day .rbc-day-slot .rbc-event {
  min-height: 18px;
}

.rbc-overlay {
  display: none !important;
}

.drag-from-allday .rbc-time-view .rbc-time-content {
  overflow-y: clip;
}`, "",{"version":3,"sources":["webpack://./src/main/Calendar/Content/DnDCalendar/DnDCalendar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,oCAAA;EACA,0CAAA;EACA,4BAAA;EACA,kBAAA;AAEF;;AACA,yCAAA;AACA;EACE,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;AAEF;;AACA,6CAAA;AACA;EACE,qBAAA;AAEF;;AACA,mDAAA;AACA;EACE,kBAAA;EACA,yCAAA;EACA,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA,wCAAA;AACA;EACE,6BAAA;AAEF;;AACA,qCAAA;AACA;EACE,qBAAA;EACA,4BAAA;EACA,8CAAA;EACA,cAAA;AAEF;;AACA;;EAEE,gBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA,8BAAA;AACA;EACE,kBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA,+BAAA;AACA;EACE,kBAAA;EACA,mBAAA;AAEF;;AACA,gBAAA;AACA;;EAEE,sCAAA;EACA,6BAAA;EACA,+BAAA;EACA,uCAAA;AAEF;;AACA;;EAEE,iBAAA;EACA,mBAAA;AAEF;;AACA;EACE,iBAAA;EACA,iBAAA;AAEF;;AACA;;;EAGE,YAAA;AAEF;;AACA;EACE,UAAA;EACA,gBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AACA,oCAAA;AACA;EACE,qBAAA;EACA,8CAAA;EACA,4BAAA;AAEF;;AACA,8BAAA;AACA;EACE,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA,gCAAA;AACA;EACE,6BAAA;AAEF;;AACA,uCAAA;AACA;EACE,kBAAA;EACA,yCAAA;EACA,yBAAA;AAEF;;AACA,uCAAA;AACA;;EAEE,gBAAA;AAEF;;AACA,wDAAA;AACA;EACE,aAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;;;;EAIE,YAAA;AAEF;;AACA;EACE,qCAAA;AAEF;;AACA;;EAUE,aAAA;AANF;;AASA;EACE,qCAAA;AANF;;AASA,gCAAA;AACA;EACE,UAAA;EACA,WAAA;EACA,2CAAA;AANF;;AASA,gCAAA;AACA;EACE,wCAAA;EACA,mBAAA;AANF;;AASA,0CAAA;AACA;EACE;IACE,uEAAA;IACA,qBAAA;EANF;AACF;AASA;;EAEE,wBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,yCAAA;EACA,wBAAA;AAPF;;AAUA,oDAAA;AACA;EACE,aAAA;AAPF;;AAUA,kBAAA;AACA;;EAEE,WAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;EACA,wBAAA;EACA,2BAAA;AAPF;;AAUA;;EAEE,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,cAAA;AAPF;;AAUA;;EAEE,iBAAA;EACA,uCAAA;AAPF;;AAUA;;EAEE,gBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAUA;;EAEE,sBAAA;AAPF;;AAUA;EACE,WAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,8CAAA;EACA,qBAAA;AAPF;;AAUA;;EAEE,gCAAA;EACA,qBAAA;AAPF;;AAUA;EACE,gCAAA;EACA,qBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;;EAEE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;AAPF;;AAUA;;;EAGE,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,cAAA;AAPF;;AAUA;EACE,gCAAA;EACA,0CAAA;EACA,aAAA;AAPF;;AAUA;EACE,gCAAA;EACA,aAAA;AAPF;;AAUA;EACE,kCAAA;EACA,gDAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,2DAAA;EACA,0BAAA;EACA,8CAAA;EACA,4DAAA;EACA,+DAAA;AAPF;;AAUA;EACE,8CAAA;EACA,4DAAA;EACA,+DAAA;AAPF;;AAUA;EACE,8CAAA;EACA,6BAAA;EACA,4DAAA;EACA,+DAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;;;EAGE,0CAAA;AAPF;;AAUA;EACE,qBAAA;EACA,aAAA;AAPF;;AAUA;EACE,kCAAA;EACA,qCAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,yDAAA;EACA,0BAAA;EACA,mCAAA;EACA,iDAAA;EACA,oDAAA;AAPF;;AAUA;EACE,mCAAA;EACA,iDAAA;EACA,oDAAA;AAPF;;AAUA;EACE,mCAAA;EACA,6BAAA;EACA,iDAAA;EACA,oDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;;EAEE,+BAAA;AAPF;;AAUA;EACE,wBAAA;EACA,aAAA;AAPF;;AAUA;EACE,kCAAA;EACA,wCAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,0DAAA;EACA,0BAAA;EACA,sCAAA;EACA,oDAAA;EACA,uDAAA;AAPF;;AAUA;EACE,sCAAA;EACA,oDAAA;EACA,uDAAA;AAPF;;AAUA;EACE,sCAAA;EACA,6BAAA;EACA,oDAAA;EACA,uDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;;EAEE,kCAAA;AAPF;;AAUA;EACE,0BAAA;EACA,aAAA;AAPF;;AAUA;EACE,kCAAA;EACA,0CAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,yDAAA;EACA,0BAAA;EACA,wCAAA;EACA,sDAAA;EACA,yDAAA;AAPF;;AAUA;EACE,wCAAA;EACA,sDAAA;EACA,yDAAA;AAPF;;AAUA;EACE,wCAAA;EACA,6BAAA;EACA,sDAAA;EACA,yDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;EACE,qDAAA;AAPF;;AAUA;EACE,wDAAA;AAPF;;AAUA;;EAEE,oCAAA;AAPF;;AAUA;EACE,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,4BAAA;EACA,8CAAA;AAPF;;AAUA;EACE,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;AAPF;;AAUA;EACE,4BAAA;EACA,8CAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAPF;;AAUA;EACE,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,WAAA;EACA,cAAA;AAPF;;AAUA,SAAA;AACA;EACE,uBAAA;AAPF;;AAUA;EACE,6BAAA;AAPF;;AAUA;EACE,qCAAA;AAPF;;AAUA;EACE,uCAAA;AAPF;;AAUA;EACE,qCAAA;AAPF;;AAUA;EACE,oCAAA;AAPF;;AAUA;;EAEE,iBAAA;EACA,cAAA;AAPF;;AAUA;;EAEE,gBAAA;AAPF;;AAUA;EACE,aAAA;AAPF;;AAUA,gCAAA;AACA;EACE,UAAA;EACA,WAAA;EACA,2CAAA;AAPF;;AAUA,gCAAA;AACA;EACE,wCAAA;EACA,mBAAA;AAPF;;AAUA,0CAAA;AACA;EACE;IACE,uEAAA;IACA,qBAAA;EAPF;AACF;AAUA;EACE,aAAA;AARF;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA,4BAAA;AACA;EACE,qBAAA;EACA,8CAAA;EACA,4BAAA;EACA,gBAAA;AARF;;AAWA,6BAAA;AACA;EACE,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,gBAAA;AARF;;AAWA;EACE,6BAAA;AARF;;AAWA;EACE,kBAAA;EACA,yCAAA;EACA,yBAAA;AARF;;AAWA;EACE,UAAA;EACA,iBAAA;AARF;;AAWA;EACE,sCAAA;AARF;;AAWA;EACE,0CAAA;EACA,gCAAA;EACA,4BAAA;EACA,8CAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AARF;;AAWA,uCAAA;AACA;EACE,0CAAA;EACA,kBAAA;EACA,wBAAA;AARF;;AAWA;;EAEE,gBAAA;AARF;;AAWA;EACE,wBAAA;AARF;;AAWA;EACE,gBAAA;AARF","sourcesContent":[".container {\n  --scrollbar-bg-color: var(--base-10);\n  --scrollbar-thumb-color: var(--base-70_30);\n  overscroll-behavior: contain;\n  position: relative;\n}\n\n/* month cell номер дня текущего месяца */\n.view-month .rbc-date-cell .month-day {\n  font: var(--font-body-4);\n  text-align: left;\n  color: var(--base-110);\n  display: flex;\n  padding: 4px;\n}\n\n/* month cell номер дня вне текущего месяца */\n.view-month .rbc-date-cell.rbc-off-range .month-day {\n  color: var(--base-80);\n}\n\n/* month cell номер дня текущего месяца выделение */\n.view-month .rbc-date-cell.rbc-now .month-day .month-day-content {\n  border-radius: 50%;\n  background-color: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n.view-month .rbc-date-cell .month-day .month-day-content {\n  width: 40px;\n  padding: 8px 0px;\n  text-align: center;\n}\n\n.view-month .rbc-date-cell {\n  /* padding: 4px; */\n}\n\n/* month cell удаление bg текущего дня */\n.view-month .rbc-month-row .rbc-today {\n  background-color: transparent;\n}\n\n/* month header с именем дня недели */\n.view-month .month-day-name-header {\n  color: var(--base-80);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  padding: 4px 0;\n}\n\n.view-week .rbc-time-column .rbc-timeslot-group,\n.view-day .rbc-time-column .rbc-timeslot-group {\n  min-height: 80px;\n}\n\n.view-day .rbc-time-column .rbc-timeslot-group {\n  border-bottom: none;\n}\n\n/* day левая колонка времени */\n.view-day .rbc-time-column.rbc-time-gutter .rbc-timeslot-group {\n  position: relative;\n}\n\n.view-day .rbc-time-column.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {\n  text-align: center;\n}\n\n/* week левая колонка времени */\n.view-week .rbc-time-column.rbc-time-gutter .rbc-timeslot-group {\n  position: relative;\n  border-bottom: none;\n}\n\n/* week header */\n.view-week .rbc-time-header,\n.view-day .rbc-time-header {\n  box-shadow: 0 1px 8px 0 var(--base-20);\n  border-inset-inline-end: none;\n  margin-inline-end: 0 !important;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.view-week .rbc-time-header-content,\n.view-day .rbc-time-header-content {\n  border-left: none;\n  padding-bottom: 8px;\n}\n\n.is-compact-view.view-day .rbc-time-header-content {\n  border-left: none;\n  padding-bottom: 0;\n}\n\n.view-week .rbc-time-header-cell .rbc-header + .rbc-header,\n.rbc-time-header-cell .rbc-header,\n.rbc-allday-cell .rbc-day-bg + .rbc-day-bg {\n  border: none;\n}\n\n.view-week .rbc-header {\n  padding: 0;\n  text-align: left;\n}\n\n.view-week .week-header {\n  width: 40px;\n  padding-top: 4px;\n}\n\n/* week header с именем дня недели */\n.view-week .week-name-header {\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  font: var(--font-subtitle-4);\n}\n\n/* week header с номером дня */\n.view-week .week-day-header {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  width: 40px;\n  padding: 8px 0px;\n}\n\n/* week header текущая колонка */\n.view-week .rbc-today {\n  background-color: transparent;\n}\n\n/* week header с номером текущего дня */\n.view-week .rbc-today .week-day-header {\n  border-radius: 50%;\n  background-color: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n/* week header wrapper с датой и днем */\n.view-week .rbc-time-view .rbc-row,\n.view-day .rbc-time-view .rbc-row {\n  min-height: auto;\n}\n\n/* week label у недели (не получается кастомизировать) */\n.view-week .rbc-day-slot .rbc-event-label {\n  display: none;\n}\n\n.is-compact-view.view-day .rbc-time-view {\n  padding-left: 8px;\n}\n\n.view-week .rbc-time-view,\n.view-week .rbc-time-content,\n.view-day .rbc-time-view,\n.view-day .rbc-time-content {\n  border: none;\n}\n\n.view-day .rbc-time-content > *:not(.rbc-time-gutter) {\n  border-left: 1px solid var(--base-20);\n}\n\n.view-day\n  .rbc-time-content\n  > .rbc-time-gutter\n  .rbc-timeslot-group:first-child\n  .rbc-time-slot:first-child,\n.view-week\n  .rbc-time-content\n  > .rbc-time-gutter\n  .rbc-timeslot-group:first-child\n  .rbc-time-slot:first-child {\n  display: none;\n}\n\n.view-week .rbc-time-content > *:not(.rbc-time-gutter) {\n  border-left: 1px solid var(--base-20);\n}\n\n/* Works on Safari, Safari iOS */\n.rbc-time-content::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  background-color: var(--scrollbar-bg-color);\n}\n\n/* Works on Safari, Safari iOS */\n.rbc-time-content::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb-color);\n  border-radius: 10px;\n}\n\n/* Works on Firefox, Chrome, Edge, Opera */\n@supports (scrollbar-color: #888 #f1f1f1) {\n  .container {\n    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);\n    scrollbar-width: thin;\n  }\n}\n\n.view-day .rbc-current-time-indicator,\n.view-week .rbc-current-time-indicator {\n  display: flex !important;\n  border: none;\n  z-index: 0;\n  height: 1px;\n  background-color: var(--brand-primary-40);\n  margin-inline-start: 4px;\n}\n\n/* day label у дня (не получается кастомизировать) */\n.view-day .rbc-event .rbc-event-label {\n  display: none;\n}\n\n/* Цветная точка */\n.view-day .rbc-current-time-indicator::after,\n.view-week .rbc-current-time-indicator::after {\n  content: '';\n  display: block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--brand-primary-40);\n  margin-inline-start: 0;\n  z-index: 1;\n  position: absolute;\n  inset-inline-start: -8px;\n  transform: translateY(-50%);\n}\n\n.view-day .rbc-timeslot-group .rbc-time-slot .rbc-label,\n.view-week .rbc-timeslot-group .rbc-time-slot .rbc-label {\n  display: inline-block;\n  min-width: 38px;\n  box-sizing: content-box;\n  transform:translateY(-9px);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-90);\n  padding: 0 8px;\n}\n\n.view-day .rbc-day-slot .rbc-timeslot-group,\n.view-week .rbc-day-slot .rbc-timeslot-group {\n  border-left: none;\n  border-bottom: 1px solid var(--base-20);\n}\n\n.view-day .rbc-timeslot-group .rbc-time-slot,\n.view-week .rbc-timeslot-group .rbc-time-slot {\n  border-top: none;\n}\n\n.view-week .rbc-time-column.rbc-time-gutter .rbc-timeslot-group .rbc-time-slot {\n  text-align: center;\n}\n\n.view-day .rbc-day-slot .rbc-events-container,\n.view-week .rbc-day-slot .rbc-events-container {\n  margin-inline-end: 6px;\n}\n\n.rbc-show-more {\n  width: 100%;\n  background-color: var(--base-17);\n  border-radius: 4px;\n  padding: 0 4px;\n  text-align: center;\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-90);\n}\n\n.rbc-row-segment .rbc-show-more:hover,\n.rbc-row-segment .rbc-show-more:focus {\n  background-color: var(--base-20);\n  color: var(--base-90);\n}\n\n.rbc-row-segment .rbc-show-more:active {\n  background-color: var(--base-20);\n  color: var(--base-90);\n}\n\n.view-month .rbc-row-segment:has(.rbc-show-more) {\n  /* min-height: 30px; */\n}\n\n.view-day .rbc-row-segment,\n.view-week .rbc-row-segment {\n  padding-top: 0px;\n  padding-bottom: 1px;\n  padding-inline-start: 0px;\n  padding-inline-end: 1px;\n}\n\n.view-month .rbc-row-segment {\n  padding-top: 0px;\n  padding-bottom: 1px;\n  padding-inline-start: 2px;\n  padding-inline-end: 3px;\n}\n\n.view-day .rbc-event,\n.view-week .rbc-event,\n.view-month .rbc-event {\n  border: none;\n  border-radius: 4px;\n  letter-spacing: var(--font-spacing-subtitle-3);\n  padding: 0 4px;\n}\n\n.rbc-event:has(.event-container-template) {\n  color: var(--brand-secondary-70);\n  background-color: var(--brand-secondary-0);\n  outline: none;\n}\n\n.rbc-event:has(.purple) {\n  color: var(--brand-secondary-70);\n  outline: none;\n}\n\n.rbc-event:has(.purple):has(.strike) {\n  text-decoration-line: line-through;\n  text-decoration-color: var(--brand-secondary-70);\n}\n\n.rbc-event:has(.purple):has(.disabled) {\n  opacity: 0.5;\n}\n\n.rbc-event:has(.sharding):has(.purple) {\n  background-image: url('/static/images/purple-sharding.png');\n  background-size: 12px 12px;\n  background-color: var(--brand-secondary-40_10);\n  --event-background-hover-color: var(--brand-secondary-40_20);\n  --event-background-selected-color: var(--brand-secondary-40_30);\n}\n\n.rbc-event:has(.filled):has(.purple) {\n  background-color: var(--brand-secondary-40_10);\n  --event-background-hover-color: var(--brand-secondary-40_20);\n  --event-background-selected-color: var(--brand-secondary-40_30);\n}\n\n.rbc-event:has(.stroke):has(.purple) {\n  border: 1px solid var(--brand-secondary-40_40);\n  background-color: transparent;\n  --event-background-hover-color: var(--brand-secondary-40_10);\n  --event-background-selected-color: var(--brand-secondary-40_20);\n}\n\n.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.sharding):has(.purple):not(:has(.disabled)):focus,\n.rbc-event:has(.filled):has(.purple):not(:has(.disabled)):focus,\n.rbc-event:has(.stroke):has(.purple):not(:has(.disabled)):focus {\n  background-color: var(--brand-secondary-0);\n}\n\n.rbc-event:has(.blue) {\n  color: var(--info-70);\n  outline: none;\n}\n\n.rbc-event:has(.blue):has(.strike) {\n  text-decoration-line: line-through;\n  text-decoration-color: var(--info-70);\n}\n\n.rbc-event:has(.blue):has(.disabled) {\n  opacity: 0.5;\n}\n\n.rbc-event:has(.sharding):has(.blue) {\n  background-image: url('/static/images/blue-sharding.png');\n  background-size: 12px 12px;\n  background-color: var(--info-40_10);\n  --event-background-hover-color: var(--info-40_20);\n  --event-background-selected-color: var(--info-40_30);\n}\n\n.rbc-event:has(.filled):has(.blue) {\n  background-color: var(--info-40_10);\n  --event-background-hover-color: var(--info-40_20);\n  --event-background-selected-color: var(--info-40_30);\n}\n\n.rbc-event:has(.stroke):has(.blue) {\n  border: 1px solid var(--info-40_40);\n  background-color: transparent;\n  --event-background-hover-color: var(--info-40_10);\n  --event-background-selected-color: var(--info-40_20);\n}\n\n.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.filled):has(.blue):not(:has(.disabled)):focus,\n.rbc-event:has(.stroke):has(.blue):not(:has(.disabled)):focus {\n  background-color: var(--info-0);\n}\n\n.rbc-event:has(.green) {\n  color: var(--success-70);\n  outline: none;\n}\n\n.rbc-event:has(.green):has(.strike) {\n  text-decoration-line: line-through;\n  text-decoration-color: var(--success-70);\n}\n\n.rbc-event:has(.green):has(.disabled) {\n  opacity: 0.5;\n}\n\n.rbc-event:has(.sharding):has(.blue) {\n  background-image: url('/static/images/green-sharding.png');\n  background-size: 12px 12px;\n  background-color: var(--success-40_10);\n  --event-background-hover-color: var(--success-40_20);\n  --event-background-selected-color: var(--success-40_30);\n}\n\n.rbc-event:has(.filled):has(.green) {\n  background-color: var(--success-40_10);\n  --event-background-hover-color: var(--success-40_20);\n  --event-background-selected-color: var(--success-40_30);\n}\n\n.rbc-event:has(.stroke):has(.green) {\n  border: 1px solid var(--success-40_40);\n  background-color: transparent;\n  --event-background-hover-color: var(--success-40_10);\n  --event-background-selected-color: var(--success-40_20);\n}\n\n.rbc-event:has(.filled):has(.green):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.filled):has(.green):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.filled):has(.green):not(:has(.disabled)):focus,\n.rbc-event:has(.stroke):has(.green):not(:has(.disabled)):focus {\n  background-color: var(--success-0);\n}\n\n.rbc-event:has(.pink) {\n  color: var(--auxillary-70);\n  outline: none;\n}\n\n.rbc-event:has(.pink):has(.strike) {\n  text-decoration-line: line-through;\n  text-decoration-color: var(--auxillary-70);\n}\n\n.rbc-event:has(.pink):has(.disabled) {\n  opacity: 0.5;\n}\n\n.rbc-event:has(.sharding):has(.pink) {\n  background-image: url('/static/images/pink-sharding.png');\n  background-size: 12px 12px;\n  background-color: var(--auxillary-40_10);\n  --event-background-hover-color: var(--auxillary-40_20);\n  --event-background-selected-color: var(--auxillary-40_30);\n}\n\n.rbc-event:has(.filled):has(.pink) {\n  background-color: var(--auxillary-40_10);\n  --event-background-hover-color: var(--auxillary-40_20);\n  --event-background-selected-color: var(--auxillary-40_30);\n}\n\n.rbc-event:has(.stroke):has(.pink) {\n  border: 1px solid var(--auxillary-40_40);\n  background-color: transparent;\n  --event-background-hover-color: var(--auxillary-40_10);\n  --event-background-selected-color: var(--auxillary-40_20);\n}\n\n.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):hover {\n  background-color: var(--event-background-hover-color);\n}\n\n.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):active {\n  background-color: var(--event-background-selected-color);\n}\n\n.rbc-event:has(.filled):has(.pink):not(:has(.disabled)):focus,\n.rbc-event:has(.stroke):has(.pink):not(:has(.disabled)):focus {\n  background-color: var(--auxillary-0);\n}\n\n.rbc-day-slot .rbc-event-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.event-container {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n}\n\n.event-container-content {\n  white-space: nowrap;\n}\n\n.event-container-content-wrap {\n  display: flex;\n  flex-direction: column;\n}\n\n.event-content-title {\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  margin-inline-end: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.event-content-sub-title {\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.event-content-prev-sub-title {\n  margin-inline-end: 2px;\n}\n\n.view-month .rbc-month-view {\n  border: 0px;\n  overflow: auto;\n}\n\n/* TODO */\n.view-month .rbc-month-row {\n  min-height: fit-content;\n}\n\n.view-month .rbc-off-range-bg {\n  background-color: transparent;\n}\n\n.view-month .rbc-header + .rbc-header {\n  border-left: 1px solid var(--base-20);\n}\n\n.view-month .rbc-header {\n  border-bottom: 1px solid var(--base-20);\n}\n\n.view-month .rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid var(--base-20);\n}\n\n.view-month .rbc-month-row + .rbc-month-row {\n  border-top: 1px solid var(--base-20);\n}\n\n.view-day .rbc-addons-dnd-row-body,\n.view-week .rbc-addons-dnd-row-body {\n  max-height: 200px;\n  overflow: auto;\n}\n\n.view-day .rbc-addons-dnd-row-body:has(.rbc-row-segment),\n.view-week .rbc-addons-dnd-row-body:has(.rbc-row-segment) {\n  margin-top: 16px;\n}\n\n.is-compact-view.view-day .rbc-addons-dnd-row-body:has(.rbc-row-segment) {\n  margin: 8px 0;\n}\n\n/* Works on Safari, Safari iOS */\n.rbc-addons-dnd-row-body::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  background-color: var(--scrollbar-bg-color);\n}\n\n/* Works on Safari, Safari iOS */\n.rbc-addons-dnd-row-body::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb-color);\n  border-radius: 10px;\n}\n\n/* Works on Firefox, Chrome, Edge, Opera */\n@supports (scrollbar-color: #888 #f1f1f1) {\n  .rbc-addons-dnd-row-body {\n    scrollbar-color: var(--scrollbar-thumb-color) var(--scrollbar-bg-color);\n    scrollbar-width: thin;\n  }\n}\n\n.view-day .rbc-time-header-cell-single-day {\n  display: flex;\n}\n\n.is-compact-view.view-day .rbc-time-header-cell-single-day {\n  display: none;\n}\n\n.rbc-row-content {\n  z-index: 0;\n}\n\n/* day header с именем дня */\n.view-day .day-name-header {\n  color: var(--base-80);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  font: var(--font-subtitle-4);\n  padding-top: 4px;\n}\n\n/* day header с номером дня */\n.view-day .day-number-header {\n  color: var(--base-110);\n  font: var(--font-body-4);\n  width: 40px;\n  padding: 8px 0px;\n}\n\n.view-day .rbc-today {\n  background-color: transparent;\n}\n\n.view-day .rbc-today .day-number-header {\n  border-radius: 50%;\n  background-color: var(--brand-primary-40);\n  color: var(--addition-50);\n}\n\n.view-day .rbc-header {\n  padding: 0;\n  text-align: start;\n}\n\n.view-month .container-toolbar {\n  box-shadow: 0 1px 8px 0 var(--base-20);\n}\n\n.rbc-slot-selection {\n  background-color: var(--brand-secondary-0);\n  color: var(--brand-secondary-70);\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  border-radius: 4px;\n  box-sizing: border-box;\n  padding: 0 3px;\n  width: calc(100% - 6px);\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n/* На месяц/алдей — выделение клеток: */\n.rbc-selected-cell {\n  background-color: var(--brand-secondary-0);\n  border-radius: 4px;\n  height: calc(100% - 6px);\n}\n\n.view-week .rbc-day-slot .rbc-event,\n.view-day .rbc-day-slot .rbc-event {\n  min-height: 18px;\n}\n\n.rbc-overlay {\n  display: none !important;\n}\n\n.drag-from-allday .rbc-time-view .rbc-time-content {\n  overflow-y: clip;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
